var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.59 158.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d302a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.59,6V158.18H0V26.71a31.69,31.69,0,0,1,3.08,3.81c8,.23,16,.76,24,1.26L30,32A155,155,0,0,1,31,16.3c.53-4.64.3-11,5-14.35s12-2.32,13.76,3c.77,2.32.51,4.87.51,7.24,0,2.88,0,5.77,0,8.65,0,4,0,8,0,12l3.64,0q0-7.16,0-14.3c0-2.66,0-5.33,0-8,0-2.28.32-4.71,2.51-6.33S61.86,2.59,64.65,3c3,.43,5.15,2.15,5.47,4.7a72.07,72.07,0,0,1,.22,8.05q.07,4,.07,8c0,2.74,0,5.49,0,8.23,5.2-.54,10.36-1.36,15.54-2.42a39,39,0,0,1,15.71-.08c5.2,1,10.26,2.37,15.49,3.29,7,1.23,14,2.09,21.11,2.8,4.16.07,8.32.06,12.48,0,12-.12,24-.52,36-.19a308.07,308.07,0,0,1,36.59,3.54l9.88,1.48q15.71,0,31.41-.4a14,14,0,0,1,5.28-1.94,31.78,31.78,0,0,1,9.34.34c.8-8,10.52-14.77,20.46-13.14a2.77,2.77,0,0,1,1.22.5,18.11,18.11,0,0,1,8.38-4.88,21.16,21.16,0,0,1,12.6.66c1.59.54,3.6,1.46,5.37,1.05a7.11,7.11,0,0,0,3-1.9c2.54-2.29,4.77-4.41,8.33-5.63s7.31-1.45,11.06-1.86c3-.32,6.28-.72,8.7-2.32,1.69-1.12,3-2.54,4.78-3.59A11.23,11.23,0,0,1,366.59,6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuImage);
export default __webpack_public_path__ + "static/media/MOBILE-menu-image.141e5780570a0edb840721a9f094fdc7.svg";
export { ForwardRef as ReactComponent };